import { Component, ojs, app } from "modular-openscriptjs";
import { cleanDispose, store } from "../../helpers";
import { tool } from "../../fotastart";

const h = app("h");

export default class AddToHomescreenModal extends Component {
    modal = null;

    render(...args) {
        return h.div({ class: "d-none" }, ...args);
    }

    showForm() {
        if (this.modal) {
            cleanDispose(this.modal);
        }

        const step = (icon, text) =>
            h.div(
                { class: "d-flex align-items-center gap-3 mb-3" },
                h.div(
                    {
                        class: "d-flex align-items-center justify-content-center bg-light rounded-circle flex-shrink-0",
                        style: "width: 40px; height: 40px;",
                    },
                    h.i({ class: `${icon} text-dark`, style: "font-size: 1.1rem;" }),
                ),
                h.div({ class: "text-start" }, text),
            );

        let content = h.div(
            {
                class: "modal-content border-0 shadow-lg rounded-4 overflow-hidden",
            },
            h.div(
                { class: "modal-body p-4 text-center" },
                h.div(
                    { class: "mb-3" },
                    h.i({
                        class: "bi bi-apple",
                        style: "font-size: 2.5rem;",
                    }),
                ),
                h.h5({ class: "fw-bold mb-2" }, "Add Carata to Your Home Screen"),
                h.p(
                    { class: "text-muted mb-4" },
                    "Carata isn't on the App Store yet, but you can add it to your Home Screen for the same one-tap experience.",
                ),
                h.div(
                    { class: "text-start mx-auto", style: "max-width: 320px;" },
                    step(
                        "fa-solid fa-arrow-up-from-bracket",
                        h.span({}, "Tap the ", h.strong({}, "Share"), " icon in Safari's toolbar."),
                    ),
                    step(
                        "fa-solid fa-square-plus",
                        h.span({}, "Scroll down and tap ", h.strong({}, "Add to Home Screen"), "."),
                    ),
                    step(
                        "fa-solid fa-check",
                        h.span({}, "Tap ", h.strong({}, "Add"), " in the top-right corner to confirm."),
                    ),
                ),
            ),
            h.div(
                {
                    class: "modal-footer border-0 px-4 pb-4 pt-0",
                },
                h.button(
                    {
                        class: "btn btn-dark rounded-pill w-100 fw-bold shadow-sm",
                        onclick: this.method("close"),
                    },
                    "Got it",
                ),
            ),
        );

        this.modal = tool.plainModal(content, {});
        this.modal.show();
    }

    close() {
        // Clicking "Got it" is the only way out of this modal, so it
        // doubles as confirmation the steps were followed - stop showing
        // the "Get the Carata App" prompt on this device from now on.
        store("app_added_to_homescreen", true);
        this.modal?.hide();
    }

    $$homescreenGuide = {
        needs: {
            prompt: () => this.showForm(),
        },
    };

    cleanUp() {
        super.cleanUp();
        if (this.modal) cleanDispose(this.modal);
    }
}

ojs(AddToHomescreenModal);
